import React, { useState } from 'react';

const SECTION_LABELS = {
  clientDetails: 'Client Details',
  scope: 'Scope of Advice',
  riskProfile: 'Risk Profile',
  strategy: 'Recommended Strategy',
  fees: 'Fees & Costs',
  warnings: 'Warnings & Disclaimers',
};

const ComplianceCheckModal = ({ complianceData, onConfirm, onCancel, onGoToSection }) => {
  const [acknowledged, setAcknowledged] = useState(false);

  if (!complianceData) return null;

  const { warnings = [], total_checks = 0, passed_checks = 0 } = complianceData;

  return (
    <div className="soa-modal-overlay" onClick={onCancel}>
      <div className="soa-share-modal" style={{ maxWidth: '560px' }} onClick={(e) => e.stopPropagation()}>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="mb-0" style={{ color: 'var(--primary-color)' }}>
            <i className="bi bi-shield-exclamation me-2"></i>Compliance Check
          </h5>
          <button className="btn-close" onClick={onCancel}></button>
        </div>

        <div className="mb-3">
          <div className="d-flex align-items-center gap-2 mb-2">
            <span className="badge bg-warning text-dark">
              {passed_checks}/{total_checks} checks passed
            </span>
          </div>
          <p className="text-muted small mb-0">
            The following sections have missing or incomplete information. You may still finalise, but you must acknowledge these gaps.
          </p>
        </div>

        <div className="list-group list-group-flush mb-3" style={{ maxHeight: '300px', overflowY: 'auto' }}>
          {warnings.map((w, i) => (
            <div key={i} className="list-group-item px-0 py-2 d-flex justify-content-between align-items-start">
              <div>
                <div className="d-flex align-items-center gap-2">
                  <i className="bi bi-exclamation-circle text-warning"></i>
                  <span className="fw-semibold small">{w.label}</span>
                </div>
                <p className="text-muted small mb-0 ms-4">{w.issue}</p>
              </div>
              {onGoToSection && (
                <button
                  className="btn btn-sm btn-outline-secondary"
                  onClick={() => { onGoToSection(w.section); onCancel(); }}
                  title={`Go to ${SECTION_LABELS[w.section] || w.section}`}
                >
                  <i className="bi bi-arrow-right"></i>
                </button>
              )}
            </div>
          ))}
        </div>

        <div className="form-check mb-3">
          <input
            className="form-check-input"
            type="checkbox"
            id="acknowledgeGaps"
            checked={acknowledged}
            onChange={(e) => setAcknowledged(e.target.checked)}
          />
          <label className="form-check-label small" htmlFor="acknowledgeGaps">
            I acknowledge these gaps and wish to finalise this SOA regardless
          </label>
        </div>

        <div className="d-flex justify-content-end gap-2">
          <button className="btn btn-outline-secondary btn-sm" onClick={onCancel}>
            Cancel
          </button>
          <button
            className="btn btn-warning btn-sm"
            disabled={!acknowledged}
            onClick={onConfirm}
          >
            <i className="bi bi-check-lg me-1"></i>Finalise Anyway
          </button>
        </div>
      </div>
    </div>
  );
};

export default ComplianceCheckModal;
